export default{
  districts: (state) => state.districts,
  districtTo: (state) => state.districtTo,
  districtFrom: (state) => state.districtFrom
}



// WEBPACK FOOTER //
// ./src/components/district/store/getters.js